import { render, staticRenderFns } from "./commonfield.vue?vue&type=template&id=87c1e49e&scoped=true"
import script from "./commonfield.vue?vue&type=script&lang=js"
export * from "./commonfield.vue?vue&type=script&lang=js"
import style0 from "./commonfield.vue?vue&type=style&index=0&id=87c1e49e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c1e49e",
  null
  
)

export default component.exports